import { a as e } from "./dist-C5MhUQHh.js";
import { _ as t, b as n, c as r, g as i } from "./store-DiJDr6QX.js";
import { a, n as o, o as s, t as c } from "./useKbSearch-CnfBTgOS.js";
import { t as l } from "./collectionIcon-Be4I1YBb.js";
import { useEffect as u, useRef as d } from "react";
import { Fragment as f, jsx as p, jsxs as m } from "react/jsx-runtime";
import { Box as h, ButtonList as g, DropdownButton as _, DropdownButtonContext as v, EmptyState as y, FlexBox as b, Icon as x, IconButton as S, InputText as C, Text as w, Timestamp as T } from "@dixa/lib-shared-habla";
import E from "classnames";
import { Link as D, NavLink as O, Outlet as k, useParams as A } from "react-router-dom";
import { ampli as j } from "lib-shared-tracking";
var M = { articlePageContainer: "_articlePageContainer_4iwz2_1" };
//#endregion
//#region ../delivery-common/src/components/languagePickerDropdown.tsx
function N({ languageData: e, selectedLanguageId: t, setSelectedLanguageId: n }) {
	let r = e.defaultLanguage.languageId, i = [e.defaultLanguage, ...e.enabledLanguages.filter((e) => e.languageId !== r)];
	return /* @__PURE__ */ p(v.Consumer, { children: ({ toggleDropdown: e }) => /* @__PURE__ */ p(g, { children: i.map((i) => /* @__PURE__ */ m(g.Item, {
		onClick: (t) => {
			t.preventDefault(), t.stopPropagation(), e(), n(i.languageId);
		},
		isSelected: t === i.languageId,
		children: [i.description, i.languageId === r ? " (Default)" : ""]
	}, i.languageId)) }) });
}
//#endregion
//#region ../delivery-common/src/hooks/useSearchQueryEvent.ts
function P() {
	let [e] = n();
	return ({ languageId: t, searchTerms: n, origin: r, searchResults: i }) => {
		let a = (/* @__PURE__ */ new Date()).valueOf(), o = window.location.href;
		return e({ variables: {
			searchResults: i,
			searchInput: {
				languageId: t,
				searchTerms: n
			},
			ctx: {
				createdAt: a,
				origin: r,
				pageUrl: o
			}
		} });
	};
}
var F = {
	tree: "_tree_uv38j_5",
	node: "_node_uv38j_5",
	active: "_active_uv38j_15",
	categoryTitle: "_categoryTitle_uv38j_15",
	articles: "_articles_uv38j_54",
	article: "_article_uv38j_54",
	category: "_category_uv38j_15",
	topLevelCategory: "_topLevelCategory_uv38j_77",
	articleIcon: "_articleIcon_uv38j_81",
	icon: "_icon_uv38j_81",
	iconWrapper: "_iconWrapper_uv38j_86",
	nodeClosed: "_nodeClosed_uv38j_104",
	articleTitleWrapper: "_articleTitleWrapper_uv38j_118",
	articleTitle: "_articleTitle_uv38j_118"
}, I = ({ article: e }) => /* @__PURE__ */ p(O, {
	to: {
		pathname: `article/${e.id}`,
		search: window.location.search
	},
	className: ({ isActive: e }) => E(e && F.active, F.node, F.article),
	children: /* @__PURE__ */ m("div", {
		className: F.articleTitleWrapper,
		children: [/* @__PURE__ */ p("div", {
			className: E(F.iconWrapper, F.articleIcon),
			children: /* @__PURE__ */ p(x, {
				name: "file",
				className: F.icon
			})
		}), /* @__PURE__ */ p("div", {
			className: F.articleTitle,
			"data-testid": "article-node",
			children: e.title
		})]
	})
}), L = ({ category: e, className: t, isOpen: n = !0, ...r }) => {
	let { isCategoryOpen: i, setCategoryOpen: a } = o(e.id);
	return /* @__PURE__ */ m("div", {
		className: E(t, F.category, F.node, n ? F.nodeOpen : F.nodeClosed),
		...r,
		"data-testid": "category-node",
		children: [
			/* @__PURE__ */ m("div", {
				onClick: () => a(!i),
				className: F.categoryTitle,
				children: [/* @__PURE__ */ p("div", {
					className: F.iconWrapper,
					children: /* @__PURE__ */ p(x, {
						name: `angle-${i ? "down" : "right"}`,
						className: F.icon
					})
				}), e.title]
			}),
			e.articles && e.articles?.length > 0 && /* @__PURE__ */ p("div", {
				className: E(F.articles, i ? F.nodeOpen : F.nodeClosed),
				children: e.articles?.map((e) => /* @__PURE__ */ p(I, { article: e }, e.id))
			}),
			e.categories?.map((e) => /* @__PURE__ */ p(L, {
				category: e,
				isOpen: i
			}, e.id))
		]
	});
}, ee = ({ categories: e }) => /* @__PURE__ */ p("div", {
	className: F.tree,
	children: e.map((e) => /* @__PURE__ */ p(L, {
		category: e,
		className: F.topLevelCategory
	}, e.id))
}), R = {
	categoryTreeSidebar: "_categoryTreeSidebar_180yg_1",
	headingContainer: "_headingContainer_180yg_15",
	backButton: "_backButton_180yg_22",
	treeContainer: "_treeContainer_180yg_30",
	searchContainer: "_searchContainer_180yg_35",
	searchInput: "_searchInput_180yg_39"
}, z = (e) => typeof e == "object" && !!e && e.nodeType === 1, B = (e, t) => (!t || e !== "hidden") && e !== "visible" && e !== "clip", V = (e, t) => {
	if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
		let n = getComputedStyle(e, null);
		return B(n.overflowY, t) || B(n.overflowX, t) || ((e) => {
			let t = ((e) => {
				if (!e.ownerDocument || !e.ownerDocument.defaultView) return null;
				try {
					return e.ownerDocument.defaultView.frameElement;
				} catch {
					return null;
				}
			})(e);
			return !!t && (t.clientHeight < e.scrollHeight || t.clientWidth < e.scrollWidth);
		})(e);
	}
	return !1;
}, H = (e, t, n, r, i, a, o, s) => a < e && o > t || a > e && o < t ? 0 : a <= e && s <= n || o >= t && s >= n ? a - e - r : o > t && s < n || a < e && s > n ? o - t + i : 0, U = (e) => e.parentElement ?? (e.getRootNode().host || null), W = (e, t) => {
	if (typeof document > "u") return [];
	let { scrollMode: n, block: r, inline: i, boundary: a, skipOverflowHiddenElements: o } = t, s = typeof a == "function" ? a : (e) => e !== a;
	if (!z(e)) throw TypeError("Invalid target");
	let c = document.scrollingElement || document.documentElement, l = [], u = e;
	for (; z(u) && s(u);) {
		if (u = U(u), u === c) {
			l.push(u);
			break;
		}
		u != null && u === document.body && V(u) && !V(document.documentElement) || u != null && V(u, o) && l.push(u);
	}
	let d = window.visualViewport?.width ?? innerWidth, f = window.visualViewport?.height ?? innerHeight, { scrollX: p, scrollY: m } = window, { height: h, width: g, top: _, right: v, bottom: y, left: b } = e.getBoundingClientRect(), { top: x, right: S, bottom: C, left: w } = ((e) => {
		let t = window.getComputedStyle(e);
		return {
			top: parseFloat(t.scrollMarginTop) || 0,
			right: parseFloat(t.scrollMarginRight) || 0,
			bottom: parseFloat(t.scrollMarginBottom) || 0,
			left: parseFloat(t.scrollMarginLeft) || 0
		};
	})(e), T = r === "start" || r === "nearest" ? _ - x : r === "end" ? y + C : _ + h / 2 - x + C, E = i === "center" ? b + g / 2 - w + S : i === "end" ? v + S : b - w, D = [];
	for (let e = 0; e < l.length; e++) {
		let t = l[e], { height: a, width: o, top: s, right: u, bottom: x, left: S } = t.getBoundingClientRect();
		if (n === "if-needed" && _ >= 0 && b >= 0 && y <= f && v <= d && (t === c && !V(t) || _ >= s && y <= x && b >= S && v <= u)) return D;
		let C = getComputedStyle(t), w = parseInt(C.borderLeftWidth, 10), O = parseInt(C.borderTopWidth, 10), k = parseInt(C.borderRightWidth, 10), A = parseInt(C.borderBottomWidth, 10), j = 0, M = 0, N = "offsetWidth" in t ? t.offsetWidth - t.clientWidth - w - k : 0, P = "offsetHeight" in t ? t.offsetHeight - t.clientHeight - O - A : 0, F = "offsetWidth" in t ? t.offsetWidth === 0 ? 0 : o / t.offsetWidth : 0, I = "offsetHeight" in t ? t.offsetHeight === 0 ? 0 : a / t.offsetHeight : 0;
		if (c === t) j = r === "start" ? T : r === "end" ? T - f : r === "nearest" ? H(m, m + f, f, O, A, m + T, m + T + h, h) : T - f / 2, M = i === "start" ? E : i === "center" ? E - d / 2 : i === "end" ? E - d : H(p, p + d, d, w, k, p + E, p + E + g, g), j = Math.max(0, j + m), M = Math.max(0, M + p);
		else {
			j = r === "start" ? T - s - O : r === "end" ? T - x + A + P : r === "nearest" ? H(s, x, a, O, A + P, T, T + h, h) : T - (s + a / 2) + P / 2, M = i === "start" ? E - S - w : i === "center" ? E - (S + o / 2) + N / 2 : i === "end" ? E - u + k + N : H(S, u, o, w, k + N, E, E + g, g);
			let { scrollLeft: e, scrollTop: n } = t;
			j = I === 0 ? 0 : Math.max(0, Math.min(n + j / I, t.scrollHeight - a / I + P)), M = F === 0 ? 0 : Math.max(0, Math.min(e + M / F, t.scrollWidth - o / F + N)), T += n - j, E += e - M;
		}
		D.push({
			el: t,
			top: j,
			left: M
		});
	}
	return D;
}, G = (e) => !1 === e ? {
	block: "end",
	inline: "nearest"
} : ((e) => e === Object(e) && Object.keys(e).length !== 0)(e) ? e : {
	block: "start",
	inline: "nearest"
};
function K(e, t) {
	if (!e.isConnected || !((e) => {
		let t = e;
		for (; t && t.parentNode;) {
			if (t.parentNode === document) return !0;
			t = t.parentNode instanceof ShadowRoot ? t.parentNode.host : t.parentNode;
		}
		return !1;
	})(e)) return;
	let n = ((e) => {
		let t = window.getComputedStyle(e);
		return {
			top: parseFloat(t.scrollMarginTop) || 0,
			right: parseFloat(t.scrollMarginRight) || 0,
			bottom: parseFloat(t.scrollMarginBottom) || 0,
			left: parseFloat(t.scrollMarginLeft) || 0
		};
	})(e);
	if (((e) => typeof e == "object" && typeof e.behavior == "function")(t)) return t.behavior(W(e, t));
	let r = typeof t == "boolean" || t == null ? void 0 : t.behavior;
	for (let { el: i, top: a, left: o } of W(e, G(t))) {
		let e = a - n.top + n.bottom, t = o - n.left + n.right;
		i.scroll({
			top: e,
			left: t,
			behavior: r
		});
	}
}
var q = {
	node: "_node_pdhfp_1",
	nestIndentation: "_nestIndentation_pdhfp_6",
	articleNode: "_articleNode_pdhfp_10",
	active: "_active_pdhfp_16",
	searchResultNode: "_searchResultNode_pdhfp_23",
	dropdownButton: "_dropdownButton_pdhfp_28",
	categoryTitle: "_categoryTitle_pdhfp_37",
	articleMeta: "_articleMeta_pdhfp_42",
	searchResultText: "_searchResultText_pdhfp_49",
	articleRecentlyUpdated: "_articleRecentlyUpdated_pdhfp_62"
}, J = ({ node: e }) => {
	let t = e.publishedAt > Date.now() - 10080 * 60 * 1e3;
	return /* @__PURE__ */ m("span", {
		className: E({ [q.articleRecentlyUpdated]: t }),
		children: [
			"Updated",
			" ",
			/* @__PURE__ */ p(T, {
				time: e.publishedAt / 1e3,
				refreshRate: 6e4,
				relative: !0
			})
		]
	});
}, Y = ({ children: e, article: t, className: n }) => {
	let { collectionId: r } = A();
	function i() {
		r && j.knowledgeInternalKbSearchResultClicked({
			articleId: t.id,
			collectionId: r
		});
	}
	let { articleId: a } = A(), o = d(null);
	return u(() => {
		t.id === a && o.current && K(o.current, {
			block: "nearest",
			scrollMode: "if-needed"
		});
	}, [a, t]), /* @__PURE__ */ p(O, {
		ref: o,
		to: {
			pathname: `article/${t.id}`,
			search: window.location.search
		},
		className: ({ isActive: e }) => E(q.node, q.articleNode, e && q.active, n),
		onClick: i,
		"data-testid": "article-node",
		children: e
	});
}, X = ({ result: e }) => /* @__PURE__ */ m(Y, {
	article: e,
	className: q.searchResultNode,
	children: [
		/* @__PURE__ */ p(w.Heading, {
			variant: "heading-3",
			children: e.title
		}),
		/* @__PURE__ */ m(w.Paragraph, {
			variant: "5",
			className: q.articleMeta,
			children: [/* @__PURE__ */ p(J, { node: e }), e.parentCategory?.title ? ` • ${e.parentCategory.title}` : ""]
		}),
		e.searchMatchedOn?.body && /* @__PURE__ */ p("p", {
			className: E(q.articleMeta, q.searchResultText),
			dangerouslySetInnerHTML: { __html: e.searchMatchedOn?.body }
		})
	]
}), Z = 30, Q = ({ treeData: e, languageData: n, collectionId: r }) => {
	let { collection: i, categories: a } = e, { searchValue: o, setSearchValue: s, clearSearch: l, urlSearch: u } = c(), d = P(), f = n.selectedLanguage.languageId, g = t({
		variables: {
			collectionId: r,
			languageId: f,
			searchTerms: u,
			limit: Z
		},
		skip: !u,
		onCompleted: (t) => d({
			languageId: f,
			searchTerms: o,
			searchResults: t.knowledgeBase?.articleSearch?.results.map((e) => e.id) || [],
			origin: { internalKb: { id: e.collection.id } }
		})
	}), _ = g.loading || g.data || g.error;
	return /* @__PURE__ */ m(b, {
		className: R.categoryTreeSidebar,
		children: [/* @__PURE__ */ p($, {
			collection: i,
			treeData: e,
			languageData: n,
			children: /* @__PURE__ */ p(ne, {
				searchValue: o,
				setSearchValue: s,
				clearSearch: l
			})
		}), /* @__PURE__ */ m(h, {
			height: "100%",
			className: R.treeContainer,
			children: [!_ && /* @__PURE__ */ p(ee, { categories: a }), _ && /* @__PURE__ */ p(te, { ...g })]
		})]
	});
}, te = ({ loading: t, data: n, error: r }) => {
	if (t || !n) return /* @__PURE__ */ p(e, {});
	let i = n.knowledgeBase?.articleSearch.results;
	return !i || i.length === 0 || r ? /* @__PURE__ */ p(b, {
		height: "100%",
		justifyContent: "center",
		alignItems: "center",
		flexDirection: "column",
		children: /* @__PURE__ */ p(y, {
			title: r ? "There has been an issue" : "No results found for this search",
			description: r ? "Please try again" : "Please try another search term"
		})
	}) : /* @__PURE__ */ p(f, { children: i.map((e) => /* @__PURE__ */ p(X, { result: e }, e.id)) });
}, ne = ({ searchValue: e, setSearchValue: t, clearSearch: n }) => /* @__PURE__ */ p(b, {
	className: R.searchContainer,
	children: /* @__PURE__ */ p(C, {
		className: R.searchInput,
		value: e,
		onChange: (e) => t(e.target.value),
		placeholder: "Search...",
		suffix: {
			type: "custom",
			value: /* @__PURE__ */ p(b, {
				alignItems: "center",
				padding: "0 100",
				children: /* @__PURE__ */ p(S, {
					variant: "tertiary",
					disabled: !e,
					icon: e ? "close" : "search",
					onClick: e ? n : void 0
				})
			}),
			noWrap: !0
		}
	})
}), $ = ({ children: e, collection: t, languageData: n, treeData: i }) => {
	let a = r.internalKBDashboard();
	return /* @__PURE__ */ m("div", { children: [/* @__PURE__ */ m(b, {
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		className: R.headingContainer,
		children: [/* @__PURE__ */ m(b, {
			flexDirection: "row",
			alignItems: "center",
			gap: "200",
			children: [
				/* @__PURE__ */ p(D, {
					to: a,
					className: R.backButton,
					children: /* @__PURE__ */ p(x, { name: "angle-left" })
				}),
				/* @__PURE__ */ p(l, { color: i.theme.colors.icon }),
				/* @__PURE__ */ p(w.Heading, {
					variant: "heading-2",
					as: "div",
					children: t.title
				})
			]
		}), /* @__PURE__ */ p(re, { languageData: n })]
	}), e] });
}, re = ({ languageData: e }) => {
	let t = e.selectedLanguage.description, { setSelectedLanguageId: n } = a();
	return /* @__PURE__ */ p(_, {
		fixed: !0,
		dropdown: /* @__PURE__ */ p(N, {
			languageData: e,
			selectedLanguageId: e.selectedLanguage.languageId,
			setSelectedLanguageId: n
		}),
		children: t
	});
};
//#endregion
//#region src/pages/collection/collectionPage.tsx
function ie() {
	let { collectionId: t } = A();
	if (!t) throw Error("Collection ID not defined in Internal Knowledge Base collection page.");
	let { selectedLanguageId: n } = a();
	u(() => {
		j.knowledgeCollectionViewed({
			collectionId: t,
			source: "internal-kb"
		});
	}, [t]);
	let { data: r, loading: i, error: o } = s({ selectedLanguageId: n });
	if (o) throw o;
	return i || !r ? /* @__PURE__ */ p(e, {}) : /* @__PURE__ */ p(ae, {
		languageData: r,
		collectionId: t
	});
}
var ae = ({ collectionId: t, languageData: n }) => {
	let { loading: r, data: a, error: o } = i({
		variables: {
			collectionId: t,
			languageId: n.selectedLanguage.languageId
		},
		fetchPolicy: "cache-and-network"
	});
	if (o) throw o;
	if (r || !a) return /* @__PURE__ */ p(e, {});
	if (!a?.knowledgeBase) throw Error("Unable to find data for Kb");
	return /* @__PURE__ */ p(oe, {
		collectionId: t,
		languageData: n,
		treeData: a.knowledgeBase,
		children: /* @__PURE__ */ p(k, {})
	});
}, oe = ({ collectionId: e, languageData: t, treeData: n, children: r }) => /* @__PURE__ */ m(b, {
	height: "100%",
	children: [/* @__PURE__ */ p(Q, {
		collectionId: e,
		languageData: t,
		treeData: n
	}), /* @__PURE__ */ p(b, {
		className: M.articlePageContainer,
		children: r
	})]
}), se = ie;
//#endregion
export { se as default };

//# sourceMappingURL=collection-KJhIbaGY.js.map